import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewChild, Input, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs';


@Component({
    selector: "app-blogPost",
    templateUrl: "./blogPost.component.html",
    styleUrls: ["./blogPost.component.css"]
})
export class BlogPostComponent implements OnInit, OnDestroy {
    postList: Observable<any>;

    constructor(private route: ActivatedRoute, private afs: AngularFirestore) {

    }
    ngOnInit() {


        let postKey = this.route.snapshot.params['postKey'];
        this.postList = this.afs.collection('blog').doc(postKey).valueChanges();
    }
    ngOnDestroy() { }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/blog-page/blogPost/blogPost.component.ts